import { createFileRoute, redirect } from '@tanstack/react-router'
import { Flex } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PortaledBreadcrumb } from '../components/portaled-breadcrumb'
import { NetworkErrors } from '../components/network-errors'
import { useTitle } from '../hooks/use-title'
import { INDEX_WHATSAPP_BUSINESS_ACCOUNT } from '../user/permission'
import { WhatsappBusinessAccountGrid } from '../whatsapp-business-account/components/whatsapp-business-account-grid'
import { useWhatsappBusinessAccounts } from '../whatsapp-business-account-hooks'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/whatsapp-business-accounts/')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(INDEX_WHATSAPP_BUSINESS_ACCOUNT)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    component: WhatsappBusinessAccounts,
})

function WhatsappBusinessAccounts() {
    const { t } = useTranslation()
    const query = useWhatsappBusinessAccounts()

    useTitle(t('WhatsApp business accounts'))

    if (query.isPending || query.isError) {
        return <NetworkErrors query={query} />
    }

    return (
        <>
            <PortaledBreadcrumb
                items={[
                    {
                        title: t('WhatsApp business accounts'),
                    },
                ]}
            />
            <Flex
                vertical
                gap="middle"
            >
                <PageTitle
                    title={t('WhatsApp business accounts')}
                    subtitle={t('The WhatsApp lines connected to your company.')}
                    count={query.data.length}
                    className="mb-0"
                />
                <WhatsappBusinessAccountGrid accounts={query.data} />
            </Flex>
        </>
    )
}
